/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v26.2.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

import { PostConstruct, PreDestroy } from "../../../context/context";
import { removeAriaSort, setAriaDescribedBy as _setAriaDescribedBy, setAriaSort as _setAriaSort } from "../../../utils/aria";
import { RefSelector } from "../../../widgets/componentAnnotations";
import { AbstractHeaderCellComp } from "../abstractCell/abstractHeaderCellComp";

var HeaderCellComp =
/** @class */
function (_super) {
  __extends(HeaderCellComp, _super);

  function HeaderCellComp(ctrl) {
    var _this = _super.call(this, HeaderCellComp.TEMPLATE, ctrl) || this;

    _this.headerCompVersion = 0;
    _this.column = ctrl.getColumnGroupChild();
    _this.pinned = ctrl.getPinned();
    return _this;
  }

  HeaderCellComp.prototype.postConstruct = function () {
    var _this = this;

    var eGui = this.getGui();

    var setAttribute = function setAttribute(name, value, element) {
      var actualElement = element ? element : eGui;

      if (value != null && value != '') {
        actualElement.setAttribute(name, value);
      } else {
        actualElement.removeAttribute(name);
      }
    };

    var compProxy = {
      setWidth: function setWidth(width) {
        return eGui.style.width = width;
      },
      addOrRemoveCssClass: function addOrRemoveCssClass(cssClassName, on) {
        return _this.addOrRemoveCssClass(cssClassName, on);
      },
      setAriaSort: function setAriaSort(sort) {
        return sort ? _setAriaSort(eGui, sort) : removeAriaSort(eGui);
      },
      setColId: function setColId(id) {
        return setAttribute('col-id', id);
      },
      setTitle: function setTitle(title) {
        return setAttribute('title', title);
      },
      setAriaDescribedBy: function setAriaDescribedBy(value) {
        return _setAriaDescribedBy(eGui, value);
      },
      setUserCompDetails: function setUserCompDetails(compDetails) {
        return _this.setUserCompDetails(compDetails);
      },
      getUserCompInstance: function getUserCompInstance() {
        return _this.headerComp;
      }
    };
    this.ctrl.setComp(compProxy, this.getGui(), this.eResize);
    var selectAllGui = this.ctrl.getSelectAllGui();
    this.eResize.insertAdjacentElement('afterend', selectAllGui);
  };

  HeaderCellComp.prototype.destroyHeaderComp = function () {
    if (this.headerComp) {
      this.getGui().removeChild(this.headerCompGui);
      this.headerComp = this.destroyBean(this.headerComp);
      this.headerCompGui = undefined;
    }
  };

  HeaderCellComp.prototype.setUserCompDetails = function (compDetails) {
    var _this = this;

    this.headerCompVersion++;
    var versionCopy = this.headerCompVersion;
    compDetails.newAgStackInstance().then(function (comp) {
      return _this.afterCompCreated(versionCopy, comp);
    });
  };

  HeaderCellComp.prototype.afterCompCreated = function (version, headerComp) {
    if (version != this.headerCompVersion || !this.isAlive()) {
      this.destroyBean(headerComp);
      return;
    }

    this.destroyHeaderComp();
    this.headerComp = headerComp;
    this.headerCompGui = headerComp.getGui();
    this.getGui().appendChild(this.headerCompGui);
    this.ctrl.setDragSource(this.headerCompGui);
  };

  HeaderCellComp.TEMPLATE = "<div class=\"ag-header-cell\" role=\"columnheader\" unselectable=\"on\" tabindex=\"-1\">\n            <div ref=\"eResize\" class=\"ag-header-cell-resize\" role=\"presentation\"></div>\n        </div>";

  __decorate([RefSelector('eResize')], HeaderCellComp.prototype, "eResize", void 0);

  __decorate([PostConstruct], HeaderCellComp.prototype, "postConstruct", null);

  __decorate([PreDestroy], HeaderCellComp.prototype, "destroyHeaderComp", null);

  return HeaderCellComp;
}(AbstractHeaderCellComp);

export { HeaderCellComp };